import {gql} from '@apollo/client';
import {useMemo} from 'react';

import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {SchemaSSIsQuery, SchemaSSIsQueryVariables} from 'schemas/util/__generated/SchemaSSIsQuery';

export const SCHEMA_SSIS_QUERY = gql`
  query SchemaSSIsQuery @skipAudit @engComponent(name: REGISTRY) {
    tagSchemas {
      id
      interfaceConfigs {
        interface {
          id
          ... on StaticSchemaInterfaceNode {
            id
          }
        }
      }
    }
  }
`;

export interface UseSchemaSSIsByIdQueryResult {
  interfaceIdsBySchemaId: Record<string, Array<string>>;
  status: QueryResultType;
}

export default function useSchemaSSIsByIdQuery(skip: boolean = false): UseSchemaSSIsByIdQueryResult {
  const result = useSkippableBenchlingQuery<SchemaSSIsQuery, SchemaSSIsQueryVariables>(SCHEMA_SSIS_QUERY, {
    skip,
  });

  const interfaceIdsBySchemaId = useMemo(() => {
    if (result.type !== QueryResultType.SUCCESS) {
      return {};
    }
    return Object.fromEntries(
      result.data.tagSchemas.map((schema) => [
        schema.id,
        schema.interfaceConfigs.map((config) => config.interface.id),
      ])
    );
  }, [result]);

  return {
    interfaceIdsBySchemaId,
    status: result.type,
  };
}
